function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

// 分钟，小时，天
export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * 格式化日期
 * @param {}} fmt
 * @param {*} date
 * @returns
 */
export function dateFormat (fmt, date) {
  let ret
  const opt = {
    'y+': date.getFullYear().toString(), // 年
    'M+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'm+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }

  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    };
  };
  return fmt
}

// 格式化时间
export function parseTime (time, cFormat) {
  let localTime = new Date().getTimezoneOffset() * 60000 // 本地时间与GMT时间的时间偏移差
  let zone = -(new Date().getTimezoneOffset() / 60) // 获取时区
  // console.log(localTime)
  // console.log(time, cFormat)
  if (arguments.length === 0) {
    return null
  }
  if (!time) {
    return '- -'
  }
  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt((time + localTime) + 3600000 * (zone)))
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const timestr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') return ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][value]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return timestr
  }
}

export function formatTime (time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 上传文件地址中提取文件名-单个文件
export function getFileName (url) {
  if (url) {
    let urlArr = url.split('/')
    let name = urlArr[5]
    return name || ''
  } else {
    return ''
  }
}

// 上传文件地址中提取文件名-多个文件
export function getFileListName (urls) {
  if (urls && urls.length > 0) {
    let nameArr = []
    urls.forEach(item => {
      let urlArr = item.split('/')
      let name = urlArr[5] || ''
      nameArr.push(name)
    })
    let nameText = nameArr.join(',')
    return nameText
  } else {
    return ''
  }
}

/* 数字 格式化 */
export function nFormatter (num, digits) {
  const si = [{
    value: 1E18,
    symbol: 'E'
  },
  {
    value: 1E15,
    symbol: 'P'
  },
  {
    value: 1E12,
    symbol: 'T'
  },
  {
    value: 1E9,
    symbol: 'G'
  },
  {
    value: 1E6,
    symbol: 'M'
  },
  {
    value: 1E3,
    symbol: 'k'
  }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function html2Text (val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter (num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 数字输入校验
export function numberReg (val, type = 1) {
  // 1 正整数 2 数量(包含0) 3包含小数的正数 4 带1-2位小数的正数或负数
  var price = '' + val
  if (type === 1) {
    if (price.length === 1) {
      price = price.replace(/[^1-9]/g, '')
    } else {
      price = price.replace(/\D/g, '')
    }
  } else if (type === 2) {
    price = price.replace(/\D/g, '')
  } else if (type === 3) {
    price = price
      .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
      .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    // .replace(/\s+/g, '') // 去除空格
  } else if (type === 4) {
    price = price
      .replace(/[^\d.-]/g, '') // 清除“数字”和“.”以外的字符
      .replace(/^\./g, '') // 验证第一个字符是数字或符号
      .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    // .replace(/\s+/g, '') // 去除空格
  }
  if (price.indexOf('.') < 0 && price.indexOf('-') < 0 && price !== '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    price = parseFloat(price)
    // 转为字符串 继续执行下方代码
    price = price + ''
  }
  if (price.indexOf('-.') !== -1 && price !== '') { // 以上已经过滤，此处控制的是以-.开头，首位不能以-.开头
    price = parseFloat(price)
    price = price + ''
  }
  // 控制在9位
  if (price.length > 9) {
    price = (price).substr(0, 9)
  }
  return price
}

// 设置最大长度 结合下方strLength使用
export function limitLength (val) {
  return {
    maxLength: val
  }
}

// 字符串 输入位数校验并去除首尾空格
export function strLength (rule, value, callback) {
  if (value || value === 0) {
    value = value.replace(/(^\s*)|(\s*$)/g, '')
    // this.maxLength 通过 bind生成新的函数，改变this指向
    let len = this.maxLength ? this.maxLength : 9
    if (value.length > len || value.length <= 0) {
      callback(new Error('长度在 1 到 ' + len + ' 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 正整数
export function positiveInt (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^[1-9]\d*$/
    if (!reg.test(value)) {
      callback(new Error('请输入非零正整数'))
    }
    if (value.length > 9) {
      callback(new Error('长度在 1 到 9 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 年龄校验
export function ageVerify (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^[1-9]\d*$/
    if (!reg.test(value)) {
      callback(new Error('请输入非零正整数'))
    }
    if (parseInt(value) > 120) { // 年龄限制在120岁以内
      callback(new Error('请输入正确的年龄'))
    }
    callback()
  } else {
    callback()
  }
}

// 正整数 数量(包含0)
export function zeroInt (rule, value, callback) {
  // console.log(value)

  if (value || value === 0) {
    var reg = /^\d*$/
    if (!reg.test(value)) {
      callback(new Error('请输入正整数或0'))
    }
    if (value.length > 1 && (value + '').indexOf(0) == 0) {
      callback(new Error('请输入正确数值'))
    }
    if (typeof value === 'number') {
      if (value > 999999999) {
        callback(new Error('长度在 1 到 9 个字符'))
      }
    }
    if (value.length > 9) {
      callback(new Error('长度在 1 到 9 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 包含小数的正数
export function positiveFloat (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^(([1-9]\d*(\.\d{1,2})?)|(0\.\d{1,2}))$/
    if (!reg.test(value)) {
      callback(new Error('请输入最多保留两位小数的正数数值'))
    }
    if (value.length > 9) {
      callback(new Error('长度在 1 到 9 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 包含小数的正数12位
export function positiveFloat12 (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^(([1-9]\d*(\.\d{1,2})?)|(0\.\d{1,2}))$/
    if (!reg.test(value)) {
      callback(new Error('请输入最多保留两位小数的正数数值'))
    }
    if (value.length > 12) {
      callback(new Error('长度在 1 到 12 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 包含小数的正数9位, 不校验小数点后--正浮点
export function positiveFloat3 (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^\d+(\.\d+)?$/
    if (!reg.test(value)) {
      callback(new Error('请输入正数数值'))
    }
    // let num = parseFloat(value)
    // if (num >= 1000000000) {
    //   callback(new Error('数值大小应小于10'))
    // }
    callback()
  } else {
    callback()
  }
}

// 带1-2位小数的正数或负数
export function anyFloat (rule, value, callback) {
  if (value || value === 0) {
    // var reg = /^(\-|\+)?\d+(\.\d{1,2})?$ /
    var reg = /^((\-|\+)?(\d*(\.\d{1,2})?)|(0\.\d{1,2}))$/
    if (!reg.test(value)) {
      callback(new Error('请输入最多保留两位小数的数值'))
    }
    if (value.length > 9) {
      callback(new Error('长度在 1 到 9 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 由字母或者数字组成--编码校验
export function LettersNum (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^[0-9a-zA-Z\-\_\@\#]*$/
    if (!reg.test(value)) {
      callback(new Error('请输入字母、数字或符号(- _ @ #)'))
    }
    if (value.length > 50) {
      callback(new Error('长度在 1 到 50 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 只有英文数字
export function NumAndEng (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^[0-9a-zA-Z]*$/
    if (!reg.test(value)) {
      callback(new Error('请输入字母或数字'))
    }
    if (value.length > 50) {
      callback(new Error('长度在 1 到 50 个字符'))
    }
    callback()
  } else {
    callback()
  }
}

// 身份证号
export function checkIdCard (rule, value, callback) {
  if (value || value === 0) {
    var reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/
    if (!reg.test(value)) {
      callback(new Error('格式不正确'))
    }
    callback()
  } else {
    callback()
  }
}

// 邮箱
export function checkEmail (rule, value, callback) {
  if (value || value === 0) {
    var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    if (!reg.test(value)) {
      callback(new Error('格式不正确'))
    }
    callback()
  } else {
    callback()
  }
}

// 校验手机号和固定电话 随机, 3-12位 119 120等电话
export function checkPhone2 (rule, value, callback) {
  // console.log(value)

  if (value !== 0 && !value) {
    callback() // ------------------这里也可以换成不能为空，不能为空为：return callback(new Error('不能为空'))
  } else {
    // let reg = /^[(\d\-){3,13}]*$/
    let reg = /^(([0-9]{3,4}-)?[0-9]{7,8}|(1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}))$/
    // let reg = /^([\d]{3,13})*$/
    // var reg = /^(([0-9]{3,4}-)?[0-9]{7,8}|(1[1-9]\d{9}))$/ // 校验手机号和固定电话
    // console.log(reg.test(value))
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的电话'))
    }
  }
}

// 校验手机号和固定电话
export function checkPhone (rule, value, callback) {
  if (value !== 0 && !value) {
    callback() // ------------------这里也可以换成不能为空，不能为空为：return callback(new Error('不能为空'))
  } else {
    // var reg = /^(([0-9]{3,4}-)?[0-9]{7,8}|(1[1-9]\d{9}))$/ // 校验手机号和固定电话
    var reg = /^(([0-9]{3,4}-)?[0-9]{7,8}|(1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}))$/ // 校验手机号和固定电话
    // console.log(reg.test(value))
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的电话'))
    }
  }
}

// 校验手机号
export function checkMobilePhone (rule, value, callback) {
  if (value !== 0 && !value) {
    callback() // ------------------这里也可以换成不能为空，不能为空为：return callback(new Error('不能为空'))
  } else {
    var reg = /^((1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}))$/ // 校验手机号
    // console.log(reg.test(value))
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的手机号码'))
    }
  }
}

// 校验固定电话
export function checkFixedPhone (rule, value, callback) {
  if (value !== 0 && !value) {
    callback() // ------------------这里也可以换成不能为空，不能为空为：return callback(new Error('不能为空'))
  } else {
    var reg = /^(([0-9]{3,4}-)?[0-9]{7,8})$/ // 固定电话
    // console.log(reg.test(value))
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的固定电话'))
    }
  }
}

// 选项
export function filterIndex (index) {
  const EngArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', ' K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', ' V', 'W', 'X', 'Y', 'Z']
  return EngArr[index]
}

// 秒转时分秒
export function secondToDate (result) {
  var h = Math.floor(result / 3600)
  var m = Math.floor((result / 60 % 60))
  var s = Math.floor((result % 60))
  let resultName = h + '小时' + m + '分钟' + s + '秒'
  return resultName
}

// 秒转时分秒
export function secondToDime (result) {
  var h = Math.floor(result / 3600)
  var m = Math.floor((result / 60 % 60))
  var s = Math.floor((result % 60))
  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  let resultName = h + ':' + m + ':' + s
  return resultName
}

// 秒转时分秒
export function wordsNum (num) {
  switch (num) {
    case 0:
      return '一'
    case 1:
      return '二'
    case 2:
      return '三'
    case 3:
      return '四'
    case 4:
      return '五'
    case 5:
      return '六'
    case 6:
      return '七'
    case 7:
      return '八'
    case 8:
      return '九'
    case 9:
      return '十'
  }
}
